import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const REQUEST_URL = `${process.env.REACT_APP_REQUEST_URL}/api`
const API_VERSION = 'v1'

export const fetchAdminWeddingStats = createAsyncThunk(
	'admin/fetchWeddingStats',
	async (_, { rejectWithValue }) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/admin/stats/weddings`,
				{
					method: 'GET',
					credentials: 'include',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				}
			)
			const data = await res.json()
			if (!res.ok) {
				return rejectWithValue(
					data.message || `Request failed (${res.status})`
				)
			}
			if (!data.success) {
				return rejectWithValue(data.message || 'Failed to load stats')
			}
			return data.stats
		} catch (err) {
			return rejectWithValue(err.message || 'Network error')
		}
	}
)

export const fetchAdminVendorStats = createAsyncThunk(
	'admin/fetchVendorStats',
	async (_, { rejectWithValue }) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/admin/stats/vendors`,
				{
					method: 'GET',
					credentials: 'include',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				}
			)
			const data = await res.json()
			if (!res.ok) {
				return rejectWithValue(
					data.message || `Request failed (${res.status})`
				)
			}
			if (!data.success) {
				return rejectWithValue(data.message || 'Failed to load stats')
			}
			return data.stats
		} catch (err) {
			return rejectWithValue(err.message || 'Network error')
		}
	}
)

export const fetchAdminAccountsByWeekChart = createAsyncThunk(
	'admin/fetchAccountsByWeekChart',
	async (_, { rejectWithValue }) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/admin/charts/accounts-by-week?weeks=104`,
				{
					method: 'GET',
					credentials: 'include',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				}
			)
			const data = await res.json()
			if (!res.ok) {
				return rejectWithValue(
					data.message || `Request failed (${res.status})`
				)
			}
			if (!data.success) {
				return rejectWithValue(data.message || 'Failed to load chart')
			}
			return data.series
		} catch (err) {
			return rejectWithValue(err.message || 'Network error')
		}
	}
)

export const fetchAdminProposalValueByMonthChart = createAsyncThunk(
	'admin/fetchProposalValueByMonthChart',
	async (_, { rejectWithValue }) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/admin/charts/accepted-proposal-value-by-month`,
				{
					method: 'GET',
					credentials: 'include',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				}
			)
			const data = await res.json()
			if (!res.ok) {
				return rejectWithValue(
					data.message || `Request failed (${res.status})`
				)
			}
			if (!data.success) {
				return rejectWithValue(data.message || 'Failed to load chart')
			}
			return data.series
		} catch (err) {
			return rejectWithValue(err.message || 'Network error')
		}
	}
)

const adminFetchOpts = {
	credentials: 'include',
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
}

export const fetchPlatformFee = createAsyncThunk(
	'admin/fetchPlatformFee',
	async (_, { rejectWithValue }) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/admin/platform-fee`,
				{ method: 'GET', ...adminFetchOpts }
			)
			const data = await res.json()
			if (!res.ok) {
				return rejectWithValue(
					data.message || `Request failed (${res.status})`
				)
			}
			if (!data.success) {
				return rejectWithValue(
					data.message || 'Failed to load platform fee'
				)
			}
			return data.data
		} catch (err) {
			return rejectWithValue(err.message || 'Network error')
		}
	}
)

export const updatePlatformFee = createAsyncThunk(
	'admin/updatePlatformFee',
	async (body, { rejectWithValue }) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/admin/platform-fee`,
				{
					method: 'PUT',
					...adminFetchOpts,
					body: JSON.stringify(body),
				}
			)
			const data = await res.json()
			if (!res.ok) {
				return rejectWithValue(
					data.message || `Request failed (${res.status})`
				)
			}
			if (!data.success) {
				return rejectWithValue(
					data.message || 'Failed to update platform fee'
				)
			}
			return data.data
		} catch (err) {
			return rejectWithValue(err.message || 'Network error')
		}
	}
)

export const fetchAdminPlannedWeddingsByWeekChart = createAsyncThunk(
	'admin/fetchPlannedWeddingsByWeekChart',
	async (_, { rejectWithValue }) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/admin/charts/planned-weddings-by-week`,
				{
					method: 'GET',
					credentials: 'include',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				}
			)
			const data = await res.json()
			if (!res.ok) {
				return rejectWithValue(
					data.message || `Request failed (${res.status})`
				)
			}
			if (!data.success) {
				return rejectWithValue(data.message || 'Failed to load chart')
			}
			return data.series
		} catch (err) {
			return rejectWithValue(err.message || 'Network error')
		}
	}
)

export const fetchAdminWeddingTypes = createAsyncThunk(
	'admin/fetchWeddingTypes',
	async (_, { rejectWithValue }) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/admin/task-catalog/wedding-types`,
				{ method: 'GET', ...adminFetchOpts }
			)
			const data = await res.json()
			if (!res.ok) {
				return rejectWithValue(
					data.message || `Request failed (${res.status})`
				)
			}
			if (!data.success) {
				return rejectWithValue(
					data.message || 'Failed to load wedding types'
				)
			}
			return data.data.weddingTypes
		} catch (err) {
			return rejectWithValue(err.message || 'Network error')
		}
	}
)

export const fetchAdminTaskListTasks = createAsyncThunk(
	'admin/fetchTaskListTasks',
	async (taskListKey, { rejectWithValue }) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/admin/task-catalog/task-lists/${encodeURIComponent(taskListKey)}/tasks`,
				{ method: 'GET', ...adminFetchOpts }
			)
			const data = await res.json()
			if (!res.ok) {
				return rejectWithValue(
					data.message || `Request failed (${res.status})`
				)
			}
			if (!data.success) {
				return rejectWithValue(data.message || 'Failed to load task list')
			}
			return data.data
		} catch (err) {
			return rejectWithValue(err.message || 'Network error')
		}
	}
)

export const fetchAdminDefaultTasks = createAsyncThunk(
	'admin/fetchDefaultTasks',
	async (_, { rejectWithValue }) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/admin/task-catalog/tasks`,
				{ method: 'GET', ...adminFetchOpts }
			)
			const data = await res.json()
			if (!res.ok) {
				return rejectWithValue(
					data.message || `Request failed (${res.status})`
				)
			}
			if (!data.success) {
				return rejectWithValue(
					data.message || 'Failed to load default tasks'
				)
			}
			return data.data.tasks
		} catch (err) {
			return rejectWithValue(err.message || 'Network error')
		}
	}
)

const initialState = {
	weddingStats: null,
	weddingStatsLoading: false,
	weddingStatsError: null,
	vendorStats: null,
	vendorStatsLoading: false,
	vendorStatsError: null,
	accountsByWeekSeries: null,
	accountsByWeekChartLoading: false,
	accountsByWeekChartError: null,
	proposalValueByMonthSeries: null,
	proposalValueByMonthChartLoading: false,
	proposalValueByMonthChartError: null,
	plannedWeddingsByWeekSeries: null,
	plannedWeddingsByWeekChartLoading: false,
	plannedWeddingsByWeekChartError: null,
	platformFee: null,
	platformFeeLoading: false,
	platformFeeSaving: false,
	platformFeeError: null,
	weddingTypes: null,
	weddingTypesLoading: false,
	weddingTypesError: null,
	taskListTasks: null,
	taskListTasksLoading: false,
	taskListTasksError: null,
	defaultTasks: null,
	defaultTasksLoading: false,
	defaultTasksError: null,
}

const adminSlice = createSlice({
	name: 'admin',
	initialState,
	reducers: {
		clearWeddingStatsError: (state) => {
			state.weddingStatsError = null
		},
		clearVendorStatsError: (state) => {
			state.vendorStatsError = null
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchAdminWeddingStats.pending, (state) => {
				state.weddingStatsLoading = true
				state.weddingStatsError = null
			})
			.addCase(fetchAdminWeddingStats.fulfilled, (state, { payload }) => {
				state.weddingStatsLoading = false
				state.weddingStats = payload
			})
			.addCase(fetchAdminWeddingStats.rejected, (state, { payload }) => {
				state.weddingStatsLoading = false
				state.weddingStatsError = payload ?? 'Error loading stats'
			})
			.addCase(fetchAdminVendorStats.pending, (state) => {
				state.vendorStatsLoading = true
				state.vendorStatsError = null
			})
			.addCase(fetchAdminVendorStats.fulfilled, (state, { payload }) => {
				state.vendorStatsLoading = false
				state.vendorStats = payload
			})
			.addCase(fetchAdminVendorStats.rejected, (state, { payload }) => {
				state.vendorStatsLoading = false
				state.vendorStatsError = payload ?? 'Error loading stats'
			})
			.addCase(fetchAdminAccountsByWeekChart.pending, (state) => {
				state.accountsByWeekChartLoading = true
				state.accountsByWeekChartError = null
			})
			.addCase(
				fetchAdminAccountsByWeekChart.fulfilled,
				(state, { payload }) => {
					state.accountsByWeekChartLoading = false
					state.accountsByWeekSeries = payload
				}
			)
			.addCase(
				fetchAdminAccountsByWeekChart.rejected,
				(state, { payload }) => {
					state.accountsByWeekChartLoading = false
					state.accountsByWeekChartError =
						payload ?? 'Error loading chart'
				}
			)
			.addCase(fetchAdminProposalValueByMonthChart.pending, (state) => {
				state.proposalValueByMonthChartLoading = true
				state.proposalValueByMonthChartError = null
			})
			.addCase(
				fetchAdminProposalValueByMonthChart.fulfilled,
				(state, { payload }) => {
					state.proposalValueByMonthChartLoading = false
					state.proposalValueByMonthSeries = payload
				}
			)
			.addCase(
				fetchAdminProposalValueByMonthChart.rejected,
				(state, { payload }) => {
					state.proposalValueByMonthChartLoading = false
					state.proposalValueByMonthChartError =
						payload ?? 'Error loading chart'
				}
			)
			.addCase(fetchAdminPlannedWeddingsByWeekChart.pending, (state) => {
				state.plannedWeddingsByWeekChartLoading = true
				state.plannedWeddingsByWeekChartError = null
			})
			.addCase(
				fetchAdminPlannedWeddingsByWeekChart.fulfilled,
				(state, { payload }) => {
					state.plannedWeddingsByWeekChartLoading = false
					state.plannedWeddingsByWeekSeries = payload
				}
			)
			.addCase(
				fetchAdminPlannedWeddingsByWeekChart.rejected,
				(state, { payload }) => {
					state.plannedWeddingsByWeekChartLoading = false
					state.plannedWeddingsByWeekChartError =
						payload ?? 'Error loading chart'
				}
			)
			.addCase(fetchPlatformFee.pending, (state) => {
				state.platformFeeLoading = true
				state.platformFeeError = null
			})
			.addCase(fetchPlatformFee.fulfilled, (state, { payload }) => {
				state.platformFeeLoading = false
				state.platformFee = payload
			})
			.addCase(fetchPlatformFee.rejected, (state, { payload }) => {
				state.platformFeeLoading = false
				state.platformFeeError =
					payload ?? 'Error loading platform fee'
			})
			.addCase(updatePlatformFee.pending, (state) => {
				state.platformFeeSaving = true
				state.platformFeeError = null
			})
			.addCase(updatePlatformFee.fulfilled, (state, { payload }) => {
				state.platformFeeSaving = false
				state.platformFee = payload
			})
			.addCase(updatePlatformFee.rejected, (state, { payload }) => {
				state.platformFeeSaving = false
				state.platformFeeError =
					payload ?? 'Error updating platform fee'
			})
			.addCase(fetchAdminWeddingTypes.pending, (state) => {
				state.weddingTypesLoading = true
				state.weddingTypesError = null
			})
			.addCase(fetchAdminWeddingTypes.fulfilled, (state, { payload }) => {
				state.weddingTypesLoading = false
				state.weddingTypes = payload
			})
			.addCase(fetchAdminWeddingTypes.rejected, (state, { payload }) => {
				state.weddingTypesLoading = false
				state.weddingTypesError =
					payload ?? 'Error loading wedding types'
			})
			.addCase(fetchAdminTaskListTasks.pending, (state) => {
				state.taskListTasksLoading = true
				state.taskListTasksError = null
			})
			.addCase(fetchAdminTaskListTasks.fulfilled, (state, { payload }) => {
				state.taskListTasksLoading = false
				state.taskListTasks = payload
			})
			.addCase(fetchAdminTaskListTasks.rejected, (state, { payload }) => {
				state.taskListTasksLoading = false
				state.taskListTasksError = payload ?? 'Error loading task list'
			})
			.addCase(fetchAdminDefaultTasks.pending, (state) => {
				state.defaultTasksLoading = true
				state.defaultTasksError = null
			})
			.addCase(fetchAdminDefaultTasks.fulfilled, (state, { payload }) => {
				state.defaultTasksLoading = false
				state.defaultTasks = payload
			})
			.addCase(fetchAdminDefaultTasks.rejected, (state, { payload }) => {
				state.defaultTasksLoading = false
				state.defaultTasksError =
					payload ?? 'Error loading default tasks'
			})
	},
})

export const { clearWeddingStatsError, clearVendorStatsError } =
	adminSlice.actions
export default adminSlice.reducer
